import { get, orderBy } from 'lodash/fp';
import { createSelector } from 'reselect';
import optionValuesToLabels from '../../../../helpers/optionValuesToLabels';

export const getReservationTrackingMethodOptions = get(
  'reservation.trackingMethodOptions'
);

export const getAll = createSelector(
  getReservationTrackingMethodOptions,
  get('all')
);

export const getOrderedOptions = createSelector(
  getAll,
  orderBy('label', 'asc')
);

export const trackingMethodOptionValuesToLabels = createSelector(
  (_, values) => values,
  getAll,
  optionValuesToLabels
);

export const getIsFetching = createSelector(
  getReservationTrackingMethodOptions,
  get('fetching')
);
export const getIsFetched = createSelector(
  getReservationTrackingMethodOptions,
  get('fetched')
);

export const getFetchingError = createSelector(
  getReservationTrackingMethodOptions,
  get('fetchingError')
);
